import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaShiftList } from '@/service/tuina'

export const fetchTuinaShiftList = createAsyncThunk(
  'tuinaShiftList/fetchTuinaShiftList',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaShiftList(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载班次失败'
      )
    }
  }
)

const shiftListSlice = createSlice({
  name: 'tuinaShiftList',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaShiftList.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaShiftList.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || {}
      })
      .addCase(fetchTuinaShiftList.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default shiftListSlice.reducer
